import {lazy} from '@aboutyou/lazy-imports';
import {LoadingPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const DropDetailPage = lazy(
  () =>
    import('./DropDetailPage.eager').then(mod => ({
      default: mod.DropDetailPage,
    })),
  {
    fallback: <LoadingPageSpinner />,
    aboveTheFold: true,
  },
);
